import React from 'react';
import { CircularProgress } from '@mui/material';

const RouteLoadingComponent = ({ isLoading = false, error = null }) => {
  // Handle the loading state
  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress color="secondary" style={{ verticalAlign: 'middle' }} />
      </div>
    );
  }
  // Handle the error state
  else if (error) {
    return <div>Sorry, there was a problem loading the page.</div>;
  } else {
    return null;
  }
};

export default RouteLoadingComponent;
